/**
 * Постраничный вывод: какие строки показаны и есть ли соседние страницы. Одно правило на все списки админки —
 * ученики, курсы (разбор удобства 28.09, №4: курсов было видно 20 из 31, `total` не читался вовсе).
 */
export type PageInfo = {
  /** Номер первой показанной строки, с 1; при пустом списке 0. */
  from: number;
  to: number;
  page: number;
  pages: number;
  hasPrev: boolean;
  hasNext: boolean;
};

export function pageInfo(offset: number, limit: number, total: number): PageInfo {
  const lim = Math.max(1, Math.floor(limit) || 1);
  const off = Math.max(0, Math.floor(offset) || 0);
  const tot = Math.max(0, Math.floor(total) || 0);
  return {
    from: tot === 0 ? 0 : Math.min(off + 1, tot),
    to: Math.min(off + lim, tot),
    page: Math.floor(off / lim) + 1,
    pages: Math.max(1, Math.ceil(tot / lim)),
    hasPrev: off > 0,
    hasNext: off + lim < tot,
  };
}
